export interface SensorAlertConfigInput {
    id?: string;
    uniqueId?: string;
    sensor: string;
    minTemperature: number;
    maxTemperature: number;
    minHumidity: number;
    maxHumidity: number;
    occurenceCircles: number;
    circlesToEscalation: number;
    escalationPeriod: number;
    alertReceivers: AlertReceivers[];
}

export interface AlertReceivers {
    alert?: string;
    level: NotificationEscalationLevel;
    receiver: string;
}

export enum NotificationEscalationLevel {
    FIRST_RESPONDER = "FIRST_RESPONDER",
    SECOND_RESPONDER = "SECOND_RESPONDER",
    THIRD_RESPONDER = "THIRD_RESPONDER",
    FOURTH_RESPONDER = "FOURTH_RESPONDER",
    FIFTH_RESPONDER = "FIFTH_RESPONDER"
}


export interface SensorAlertConfigFilteringInputObject {
}
